import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { DownloadJpg } from '../../../../../../../common/downloadJpg'
import { UseI18n } from '../../../../../../../common/hooks/useI18n'
import { Element } from '../../../../../../../common/html/element'
import { Panel } from '../../../../../../../common/panel'
import { selectCompanyInfo } from '../../../../../../common/header/companyInfo/store/slice'
import { getHighlightScore, selectTypePeriod } from '../../../../../store/slice'

import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../../../../../utils/authorization'
import {
  downloadRiskDriverCompareData,
  downloadRiskDriverData,
  getBreakdownCompareThunk,
  getBreakdownThunk,
  getRiskDriverCompareThunk,
  getRiskDriverDataThunk,
} from '../../../../store/thunk'
import { parseValueToParams } from '../helper'
import RiskComponentAnalysisContent from './RiskComponentAnalysisContent'

const RiskComponentAnalysis = ({ hiddenDownload }) => {
  const location = useLocation()
  const dispatch = useDispatch()

  const label = UseI18n('riskComponentAnalysis.title')
  const locale = useSelector((state) => state.i18n.locale)
  const timeFrequency = useSelector(selectTypePeriod)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)
  const userType = useSelector(selectUserType)

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const { organizationShortName, organizationName, taxCode } =
    useSelector(selectCompanyInfo)
  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const { riskScore } = useSelector(getHighlightScore())
  const [filterTime, setFilterTime] = useState({
    from: null,
    to: null,
  })
  const { from, to } = filterTime
  const fromParams = parseValueToParams(from, timeFrequency)
  const toParams = parseValueToParams(to, timeFrequency)
  const [isCompare, setIsCompare] = useState(false)

  const labelScoreBreakdown = UseI18n('riskComponentAnalysis.scoreBreakdown')
  const labelDetails = UseI18n('score.main.DETAILS')
  const labelRelativeContributions = UseI18n(
    'riskComponentAnalysis.relativeContributions',
  )
  const disableDownload =
    AUTHORIZATION_API.companyAnalysis?.downloadPanel[userType.userTypeId] ===
    AUTHORIZATION_TYPE.DISABLE

  const renderRightHeader = () => {
    if (hiddenDownload) return null
    const downloadCsv = () => {
      if (!riskScore || disableDownload) return
      if (isCompare) {
        dispatch(
          downloadRiskDriverCompareData({
            OrganizationId: params.organizationId,
            TimeFrequency: timeFrequency,
            BaseQuarter: fromParams.Quarter,
            BaseYear: fromParams.Year,
            BaseMonth: fromParams.Month,
            CompareQuarter: toParams.Quarter,
            CompareYear: toParams.Year,
            CompareMonth: toParams.Month,
          }),
        )
      } else {
        dispatch(
          downloadRiskDriverData({
            OrganizationId: organizationId,
          }),
        )
      }
    }

    return (
      <Element className="dFlex alignItemsCenter" onClick={downloadCsv}>
        <DownloadJpg
          data={{
            disabled: !riskScore,
            arrName: [
              labelScoreBreakdown,
              labelDetails,
              organizationShortName || organizationName || taxCode || '',
            ],
            titleJpg: labelScoreBreakdown,
            domId: 'scoreBreakdownChartId',
          }}
        >
          <DownloadJpg
            data={{
              disabled: !riskScore,
              arrName: [
                labelRelativeContributions,
                labelDetails,
                organizationShortName || organizationName || taxCode || '',
              ],
              titleJpg: labelRelativeContributions,
              domId: 'relativeContributionsChartId',
            }}
          />
        </DownloadJpg>
      </Element>
    )
  }

  useEffect(() => {
    if (!filterTime?.timeFrequency) return

    if (isCompare) {
      dispatch(
        getBreakdownCompareThunk({
          OrganizationId: params.organizationId,
          TimeFrequency: timeFrequency,
          BaseQuarter: fromParams.Quarter,
          BaseYear: fromParams.Year,
          BaseMonth: fromParams.Month,
          CompareQuarter: toParams.Quarter,
          CompareYear: toParams.Year,
          CompareMonth: toParams.Month,
        }),
      )

      dispatch(
        getRiskDriverCompareThunk({
          OrganizationId: params.organizationId,
          TimeFrequency: timeFrequency,
          BaseQuarter: fromParams.Quarter,
          BaseYear: fromParams.Year,
          BaseMonth: fromParams.Month,
          CompareQuarter: toParams.Quarter,
          CompareYear: toParams.Year,
          CompareMonth: toParams.Month,
        }),
      )
    } else {
      dispatch(
        getBreakdownThunk({
          OrganizationId: params.organizationId,
          TimeFrequency: timeFrequency,
        }),
      )
      dispatch(
        getRiskDriverDataThunk({
          OrganizationId: params.organizationId,
        }),
      )
    }
  }, [isCompare, locale, filterTime])

  return (
    <Panel label={label} renderRightHeader={renderRightHeader}>
      <RiskComponentAnalysisContent
        isCompare={isCompare}
        setIsCompare={setIsCompare}
        filterTime={filterTime}
        setFilterTime={setFilterTime}
      />
    </Panel>
  )
}

export default RiskComponentAnalysis
